import { __extends } from "tslib";
import Manager from '../Abstracts/Manager';
import Application from '../../../Architecture/Core/Application';
var PopUpManager = /** @class */ (function (_super) {
    __extends(PopUpManager, _super);
    /* CONSTRUCTOR */
    function PopUpManager() {
        return _super.call(this) || this;
    }
    /* METHODS */
    PopUpManager.prototype.showPopUp = function (element, startCallback, time, endCallback) {
        var _this = this;
        Application.current.setState({ popUpVisible: true, popUp: element });
        if (time) {
            startCallback != undefined && startCallback();
            if (this.interval) {
                clearTimeout(this.interval);
            }
            this.interval = setTimeout(function () { return _this.closePopUp(endCallback); }, time);
        }
    };
    PopUpManager.prototype.closePopUp = function (callBack) {
        if (this.interval) {
            clearTimeout(this.interval);
        }
        Application.current.setState({ popUpVisible: false, popUp: undefined }, callBack != undefined ? callBack : function () { });
    };
    return PopUpManager;
}(Manager));
export default PopUpManager;
